export var PaginationDefaultValue;
(function (PaginationDefaultValue) {
    PaginationDefaultValue["XS"] = "xs";
    PaginationDefaultValue["SM"] = "sm";
    PaginationDefaultValue["MD"] = "md";
    PaginationDefaultValue["LG"] = "lg";
    PaginationDefaultValue["XL"] = "xl";
})(PaginationDefaultValue || (PaginationDefaultValue = {}));
